import styled from 'styled-components';

export const SourceContainer = styled.div`
  display: flex;
  padding-bottom: 30px;
`;

export const SearchResultsContainer = styled.div`
  margin-left: 8px;
  max-height: 300px;
  overflow: scroll;
`;

export const SectionDetails = styled.div`
  width: 100%;
`;

export const EditContainer = styled.div`
display: flex;
justify-content: flex-end;
`;

export const RightAlignContainer = styled.div`
margin-left: auto;
`;

export const ActionItemContainer = styled.div`
padding-top: 16px;
padding-right: 8px;
`;

export const ActionContainer = styled.div`
display: flex;
justify-content: flex-end;
`;
